<template>
<div>
<flash-message class="myCustomClass"></flash-message>
<v-row>
  <v-col class="text-right">
    <v-btn dark @click.stop="dialog = true">
      <v-icon>settings</v-icon>
      Preference
    </v-btn>
  </v-col>

    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="headline">Manage dashboard preference</v-card-title>
        <v-card-text>
          <v-col class="d-flex" cols="12">
            <v-select
              v-model="defaultSortPreference"
              :items="headers"
              item-text="text"
              item-value="value"
              label="Sort Dashboard Table By:"
            ></v-select>
          </v-col>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" @click="dialog = false">
            Close
          </v-btn>
          <v-btn color="green" @click="updateSortPreference()">
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
<v-card-title>
<h2>{{ ctitle }}</h2>
<v-spacer></v-spacer>
<v-select label="Select Columns to Display" :items="headers" v-model="filteredheaders" multiple return-object>
        <template v-slot:selection="{ item, index }">
        <v-chip v-if="index === 0">
          <span>{{ item.text }}</span>
        </v-chip>
        <span
          v-if="index === 1"
          class="grey--text caption"
        >(+{{ filteredheaders.length - 1 }} others)</span>
      </template>
        </v-select>
      </v-flex>

<v-btn icon class="mx-0" @click="download">
  <v-icon title="Excel Download" color="green">save_alt</v-icon>
</v-btn>

<v-btn icon class="mx-0" @click="reset">
   <v-icon title="Reload" color="blue">refresh</v-icon>
</v-btn>

<v-text-field clearable v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>

</v-card-title>

<span v-if="isAdmin == 'true'">
<v-data-table  :footer-props="{'items-per-page-options': [100,500,5000]}"  :headers="filteredheaders" :loading=progress_bar_loading :items="filteredResults" :search="search" class="elevation-1" :options.sync="pagination" group-by="uin" show-group-by :sort-by="defaultSortPreference"  multi-sort>

<v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>

<template slot="headers" slot-scope="props">
  <tr>
    <th v-for="header in props.headers" :key="header.text">{{ header.text }}</th>
  </tr>
  <tr class="grey lighten-3">
    <th v-for="header in props.headers" :key="header.text">
      <div v-if="filters.hasOwnProperty(header.value)">
        <v-select flat hide-details small multiple clearable :items="columnValueList(header.value)" v-model="filters[header.value]">
        </v-select>
      </div>
    </th>
  </tr>
</template>

<template v-slot:item.id="{ item }">
          <a :href="'/tentativecourses/indexbyuin/' + item.uin +'/' + item.semester"><v-icon title="View student info">visibility</v-icon></a>
</template>

<template v-slot:item.approved="{ item }">
        <span v-if="item.approved == 1"><v-chip color="green" dark>Yes</v-chip></span><span v-else><v-chip color="orange" dark>No</v-chip></span>
</template>

<template v-slot:item.registered="{ item }">
        <span v-if="item.registered == true"><v-chip color="green" dark>Yes</v-chip></span><span v-else><v-chip color="orange" dark>No</v-chip></span>
</template>

<template v-slot:item.coursename="{ item }">
    <span v-if="item.coursename == ''"><v-chip color="warning" dark>Course Cancelled {{item.cancelled_course_name}}</v-chip></span><span v-else>{{item.coursename}}</span>
</template>

<v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no results.</v-alert>

</v-data-table>
</span>

</v-card>

</div>
</template>

<script>
import XLSX from 'xlsx';

export default {
        data () {
                return {
app_name: process.env.MIX_APP_NAME,
search: this.search_value,
fill:[],
filteredheaders: [],
filteredheaderarray: [],
headerarray:[],
progress_bar_loading: true,
dialog: false,
                rowsPerPageItems: [10,50,100,2000],
                headers: [
                { text: 'Student uin', value: 'uin', sortable: true, },
                { text: 'Student name', value: 'full_name', sortable: true, },
                { text: 'Primary Advisor', value: 'advsr_pers_full_name', sortable: true, },
                { text: 'Semester', value: 'semester', sortable: true, },
                { text: 'Course', value: 'coursename', sortable: true, },
                { text: 'Advisor Accepted', value: 'approved', sortable: true, },
                { text: 'Created on', value: 'created_at', sortable: true, filterable: false},
                { text: 'Messages', value: 'messages_count', sortable: true, },
                { text: 'Registered', value: 'registered', sortable: true, },
                { text: 'Actions', value: 'id', sortable: false, },
                ],

                filters: {
                uin:[],
                full_name:[],
                advsr_pers_full_name:[],
                coursename:[],
                semester:[],
                created_at:[],
                },

                selected:[],
                pagination: {

                },

                Results:[],
                dialog: false,
                defaultSortPreference: '',
        }
        },
             created () {
                     this.initialize()
             },
               mounted() {
                  this.getSortPreference();
                     
 },
props: {
search_by: {
	type: String,
	required: false,
		              },
ctitle: {
             type: String,
             required: true,
                              },
    isAdmin: {
      type: String,
      required: true,
    }
  },
       computed:{
                filteredResults() {
                return this.Results.filter(d => {
                        return Object.keys(this.filters).every(f => {
                                return this.filters[f].length < 1 || this.filters[f].includes(d[f])
                        })
                })
                }
       },

methods:
       {
                columnValueList(val) {
                        return this.Results.map(d => d[val])
                },
               initialize()
               {
                        this.fetchApp()
                        this.filteredheaders = this.headers;
			this.search = this.search_by;
               },
                close () {
                        this.dialog = false
                },
               async fetchApp(){
                       await axios.get('/api/v1/tentativecourses/indexall')
                               .then((response) => {
                                               this.Results = (response.data);
                                               this.progress_bar_loading = false;
                                               })
                       .catch(error => {});

         },
          customFilter(items, search, filter) {
                    search = search.toString().toLowerCase();
                    this.fill = items.filter(i => (
                                            Object.keys(i).some(j => filter(i[j], search))
                                            ))
                    return this.fill;
            },
        reset()
                     {
                     this.fetchApp();
                     },
    download() {
      var first_record_json;
      var all_headers;
      var first_record_json;
      var first_record_json_keys;
      var all_headers_not;

      var local_delete = [];

      this.filteredheaders.forEach(element => this.filteredheaderarray.push(element.value));
      this.headers.forEach(element => this.headerarray.push(element.value));
      first_record_json = this.Results[0];

      first_record_json_keys  = Object.keys(first_record_json);
      all_headers_not = first_record_json_keys.filter(x=> !this.filteredheaderarray.includes(x));
      // local_delete = this.fill;
      local_delete = this.filteredResults; // change this when I figure out how the customFilter should work
      for (var k =0;k<local_delete.length;k++)
      {
        for(var i=0;i<all_headers_not.length;i++)
        {
                var key = all_headers_not[i];
                delete local_delete[k][key];
        }
      }
      var work = XLSX.utils.json_to_sheet(local_delete);
      var new_workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(new_workbook, work, "SheetJS");
                        var date = new Date();
      XLSX.writeFile(new_workbook, this.app_name + '_app_export_' + date.getTime() + '.xlsx');
                        this.filteredheaderarray = [];
      this.headerarray = [];
    },
    BackgroundColor: function(tcourse, key) {
      var result = '';
      if(key == 'approved')
              {
                      if(tcourse.approved == 0)
                      {
                      result = 'badge p-2 h-3 font-weight-light badge-info'
                      }
              else
          {
            result = 'badge p-2 font-weight-light badge-success'
          }
      }

      return result;
    },
    async updateSortPreference() {
      if (this.defaultSortPreference == '') {
        alert("Select sort preference");
        return;
      }
       await axios.post('/api/v1/preference', { dashboard_sort_preference: this.defaultSortPreference })
        .then((response) => {
        // this.Results = (response.data);
        if (response.data) {
          this.defaultSortPreference = response.data.dashboard_sort_preference;
        }
      })
      .catch(error => {});

      this.dialog = false;
    },
    async getSortPreference() {
       await axios.get('/api/v1/preference')
        .then((response) => {
        // this.Results = (response.data);
        if (response.data) {
          this.defaultSortPreference = response.data.dashboard_sort_preference;
        }
      })
      .catch(error => {});
      
      this.dialog = false;
    }

 }
}
</script>
